var _ellipse, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 94,
    viewBox: "0 0 125 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.1526,
    cy: 46.7404,
    rx: 56.4991,
    ry: 37.5,
    transform: "rotate(-10 62.1526 46.7404)",
    fill: "#FFC8B6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 21,
    width: 51,
    height: 51,
    fill: "url(#pattern0_7046_9265)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7046_9265",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7046_9265",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7046_9265",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryIcon);
export default __webpack_public_path__ + "static/media/RetryIcon.e693bb538a2f90869305c017b7b83ca3.svg";
export { ForwardRef as ReactComponent };